export interface GameplayTuning {
  readonly version: string
  readonly initialSpeed: number
  readonly maximumSpeed: number
  readonly speedRamp: number
  readonly lateralAcceleration: number
  readonly lateralDrag: number
  readonly maximumLateralSpeed: number
  readonly gravity: number
  readonly landingSnapDistance: number
  readonly steeringAirControl: number
  readonly playerRadius: number
  readonly killPlane: number
}

export function createDefaultTuning(): GameplayTuning {
  return Object.freeze({
    version: '1.0.0',
    initialSpeed: 24,
    maximumSpeed: 64,
    speedRamp: 0.00125,
    lateralAcceleration: 58,
    lateralDrag: 4.2,
    maximumLateralSpeed: 20,
    gravity: 42,
    landingSnapDistance: 0.28,
    steeringAirControl: 0.62,
    playerRadius: 1,
    killPlane: -18,
  })
}
